module.exports = __webpack_public_path__ + "static/img/ZG_H5.5308739.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ZG_H5.png
// module id = nEON
// module chunks = 34